import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { resetScheduleTxnDetailSlice } from "../../../../redux/features/scheduleTransaction";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import CommonToast from "../../../_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const ScheduleTransactionViewAllCard = ({
  data,
  isSidebarOpen,
  currentStatus,
  onClose,
  type,
  filterRef,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const getFormattedFrequency = (txn) => {
    const startDate = txn?.transaction_start_date;
    const frequency = txn?.frequency?.toLowerCase();

    if (!frequency) return "";

    if (!startDate && !["daily"].includes(frequency)) return "";

    const dateObj = startDate ? new Date(startDate) : null;

    const day = dateObj?.getDate();
    const weekday = dateObj?.toLocaleString("en-IN", { weekday: "short" });
    const month = dateObj?.toLocaleString("en-IN", { month: "short" });
    const year = dateObj?.getFullYear();

    const formatShortDate = () => `${day} ${month}`;
    const formatFullDate = () => `${day} ${month} ${year}`;

    switch (frequency) {
      case "weekly":
        // Weekly, on Mon
        return `on ${weekday}`;

      case "yearly":
        // Yearly, on 30 Mar
        return `on ${formatShortDate()}`;

      case "monthly":
      case "quarterly":
      case "half_yearly":
      case "fortnightly":
        // Quarterly, from 5 Jan 2025
        return `from ${formatFullDate()}`;

      case "once":
        // Once, on 30 Mar 2025
        return `on ${formatFullDate()}`;

      case "daily":
        // Daily → no date text
        return "";

      default:
        return "";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  return (
    <div className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md`}>
      {data?.map((transactions) => {
        return (
          <CardContainer
            filterRef={filterRef}
            hoverHeight={GlobalConfiguration?.beneScheduleTxnCardHoverHeight}
            key={transactions?.txn_id}
            onClickHandler={() => {
              if (type === "ScheduleAccBeneAcc") {
                CommonToast({
                  text: "Action restricted in popup mode.",
                  icon: ICONS?.ERROR_WHITE_CIRCLE,
                  variant: "var(--error)",
                });
                return;
              } else {
                onClose?.call();
                dispatch(resetScheduleTxnDetailSlice());
                navigate(
                  `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${transactions?.txn_id}`,
                  {
                    state: {
                      isViewAll:
                        location.pathname ===
                        "/beneficiary_transaction_dashboard/schedule_view_all"
                          ? true
                          : false,
                    },
                  },
                );
              }
            }}
          >
            <card-body>
              <TextWithIcon
                type={"text"}
                textCase={"capitalize"}
                text={transactions?.scheduled_name}
                subText={"Schedule name"}
                textColor={"var(--text-primary)"}
                iconComponentArray={[
                  ...(transactions?.confidential_transaction === "Y"
                    ? [
                        {
                          icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                          title: "confidential",
                          isDisabled: false,
                        },
                      ]
                    : []),
                ]}
              />

              <TextWithIcon
                type={"Amount"}
                fontWeight={"semibold"}
                text={transactions?.amount}
                subText={"Amount"}
                textColor={"var(--settled)"}
              />

              <TextWithIcon
                type={"text"}
                textCase={"capitalize"}
                text={transactions?.beneficiary_account_name
                  .toLowerCase()
                  .split(" ")
                  .map(function (word) {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                  })
                  .join(" ")}
                subText={"Account name"}
                textColor={"var(--text-primary)"}
              />

              <TextWithBank
                text={(() => {
                  const freq = transactions?.frequency?.toLowerCase();
                  const formattedFreq =
                    freq === "half_yearly"
                      ? "Half yearly"
                      : freq?.charAt(0).toUpperCase() + freq?.slice(1);
                  const formattedDate = getFormattedFrequency(transactions);

                  return formattedDate
                    ? `${formattedFreq}, ${formattedDate}`
                    : formattedFreq;
                })()}
                subText={"Frequency"}
                type={"Text"}
                ifscCode={transactions?.beneficiary_account_ifsc_code}
              />
            </card-body>
            <card-hover>
              <TextWithIcon
                text={
                  transactions?.lifecycle_status === "deleted"
                    ? "Discarded"
                    : currentStatus === "Require approval"
                      ? "Require approval"
                      : transactions?.lifecycle_status
                }
                subText={"Approval status"}
                textCase={"capitalize"}
                fontWeight="semibold"
                textColor={
                  transactions?.lifecycle_status === "deleted"
                    ? "var(--abandoned)"
                    : getStatusColor(transactions?.lifecycle_status)
                }
              />

              <TextWithIcon
                text={transactions?.category}
                subText={"Category"}
                textCase={"capitalize"}
                textColor={"var(--text-primary)"}
              />
            </card-hover>
          </CardContainer>
        );
      })}
    </div>
  );
};

export default ScheduleTransactionViewAllCard;
